import React from 'react'

import { faList } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ButtonGroup } from '@material-ui/core'
import { ToggleButton } from '@material-ui/lab'
import PropTypes from 'prop-types'

const TableViewToggle = ({ tableView, setTableView, viewIcon, viewAriaLabel, disabled }) => {
  return (
    <ButtonGroup
      aria-label="view options"
      disabled={disabled}
    >
      <ToggleButton
        selected={!tableView}
        onChange={() => setTableView(false)}
        aria-label={viewAriaLabel || 'view Chart'}
        disabled={disabled}
        value=""
      >
        <FontAwesomeIcon icon={viewIcon} />
      </ToggleButton>
      <ToggleButton
        selected={tableView}
        onChange={() => setTableView(true)}
        aria-label="view Table"
        disabled={disabled}
        value=""
      >
        <FontAwesomeIcon icon={faList} />
      </ToggleButton>
    </ButtonGroup>
  )
}

TableViewToggle.propTypes = {
  disabled: PropTypes.bool,
  tableView: PropTypes.bool.isRequired,
  setTableView: PropTypes.func.isRequired,
  viewIcon: PropTypes.any.isRequired,
  viewAriaLabel: PropTypes.string,
}

export default TableViewToggle
